import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { goddivaInvoiceByIdApi } from "../../../../services/report";

export const getInvoiceById = createAsyncThunk(
    'report/getInvoiceById',
    async (data) => {
        const response = await goddivaInvoiceByIdApi(data);
        return response.response;
    }
);

const purchaseInvoiceAdapter = createEntityAdapter({});

export const {
    selectAll: selectPurchaseInvoiceItemReport,
    selectById: selectPurchaseInvoiceItemReportById
} = purchaseInvoiceAdapter.getSelectors(
    state => state.report.purchaseInvoiceItemReport
);

const purchaseInvoiceItemReportSclice = createSlice({
    name: 'purchaseInvoiceItemReport',

    initialState: purchaseInvoiceAdapter.getInitialState({
        id: null,
        totalItems: 0,
        selectedInvoice: null,
        invoiceItems: [],
        viewLoading: true
    }),

    reducers: {
        setTableRowCount: (state, action) => {
            state.totalItems = action.payload;
        },
        clearInvoiceView: (state) => {
            state.selectedInvoice = null;
            state.invoiceItems = [];
            state.totalItems = 0;
            state.viewLoading = true;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getInvoiceById.pending, (state) => {
                state.viewLoading = true;
            })
            .addCase(getInvoiceById.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload.invoice !== undefined) {
                    state.selectedInvoice = payload.invoice;
                }
                // Handle all possible shapes: array, {results:[]}, {data:[]}, or fallback
                const raw = payload.items;
                const items = Array.isArray(raw) ? raw
                    : Array.isArray(raw?.results) ? raw.results
                    : Array.isArray(raw?.data) ? raw.data
                    : [];
                state.invoiceItems = items;
                state.totalItems = payload.total ?? payload.count ?? raw?.total ?? raw?.count ?? items.length;
                state.viewLoading = false;
            })
            .addCase(getInvoiceById.rejected, (state) => {
                state.viewLoading = false;
            });
    }
});

export const { setTableRowCount, clearInvoiceView } = purchaseInvoiceItemReportSclice.actions;

export default purchaseInvoiceItemReportSclice.reducer;
